const $ = jQuery;
const $window = $(window);

// Create anchor tag of component from [data-anchor-id].
const initAnchors = () => {
  const els = once('dom-anchor', '[data-anchor-id]');
  els.forEach((el) => {
    const $this = $(el);
    const anchorId = $this.data('anchor-id');
    const headerHeight = $('.om-header').height() || 100;

    $this.before(
      $('<div>', {
        id: anchorId,
        css: {
          position: 'relative',
          top: -headerHeight,
        },
      }),
    );
  });
};

$window.on('load', function () {
  initAnchors();
});
